module.exports = __webpack_public_path__ + "img/dgitem7.26ca1988.png";